import PropTypes from "prop-types";
import React, { useState } from "react";
import AlbumDetail from "./AlbumDetail";
import "../../style/ListAlbum.css";
const CROISSANT = false;
const DECROISSANT = true;

const ListArtworks = ({
  albumStore,
  filterAlbum = null,
  sortingType = "title",
  sortingOrder = false,
  showTitle = false,
  showGroup = false,
  showCorrectionOnFlip = false,
  onCLick = () => {},
}) => {
  const [showPopup, setShowPopup] = useState(null);

  const getListSorted = (list) => {
    let tempList = [...list];

    if (sortingType === `title`) {
      tempList = [...tempList].sort((a, b) =>
        a.albumTitle.localeCompare(b.albumTitle)
      );
    } else if (sortingType === `date`) {
      tempList = [...tempList].sort((a, b) => a.dateAlbum - b.dateAlbum);
    } else if (sortingType === `group`) {
      tempList = [...tempList].sort((a, b) => a + b);
    } else {
      tempList = [...tempList].sort((a, b) =>
        a.albumTitle.localeCompare(b.albumTitle)
      );
    }
    // croissant ou décroissant
    sortingOrder === DECROISSANT && tempList.reverse();
    // par title sinon
    return tempList;
  };

  const getListFilter = (list) => {
    return filterAlbum
      ? list.filter((album) => album.groupId === filterAlbum)
      : list;
  };

  
  return (
    <>
      <ul className="albumList">
        {getListSorted(getListFilter(albumStore.albumList)).map((album) => {
          let group = albumStore.getGroupById(album.groupId);
          return (
            <li key={album.id}>
              <AlbumDetail
                album={album}
                group={group}
                showGroup={showGroup}
                showCorrectionOnFlip={showCorrectionOnFlip}
                showTitle={showTitle}
                onCLick={onCLick}
              />
            </li>
          );
        })}
      </ul>
    </>
  );
};
ListArtworks.propTypes = {
  albumStore: PropTypes.object.isRequired,
  filterAlbum: PropTypes.string,
  sortingType: PropTypes.string,
  showTitle: PropTypes.bool,
  showGroup: PropTypes.bool,
  showCorrectionOnFlip: PropTypes.bool,
  onCLick: PropTypes.func,
};

export default ListArtworks;
